module.exports = __webpack_public_path__ + "img/img08.2e70330f.png";